import { getDisplayNameProp } from './helpers';

export function displayName(value: string) {
  return (target: any, propName: string) => {
    const displayNameProp = getDisplayNameProp(propName);
    target[displayNameProp] = value;
  };
}
